import { render, staticRenderFns } from "./MusicProperties.vue?vue&type=template&id=628fe799&"
import script from "./MusicProperties.vue?vue&type=script&lang=js&"
export * from "./MusicProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports